import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsCard = ({ title, value, change, changeType, icon, iconColor, description }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="clinical-card p-6 hover:shadow-md transition-clinical">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center" 
             style={{ backgroundColor: `${iconColor}15` }}>
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        {change && (
          <div className={`flex items-center gap-1 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={16} />
            <span className="text-sm font-semibold">{change}</span>
          </div>
        )}
      </div>

      <h3 className="text-2xl font-bold text-foreground mb-1">{value}</h3>
      <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
    </div>
  );
};

export default AnalyticsCard;